import { KeyboardEvent } from 'react';

import { EKeyboardKeycode } from './types';

export const getEnterKeycode = (event: KeyboardEvent) => {
  return event.key === EKeyboardKeycode.ENTER || event.key === EKeyboardKeycode.NUMPAD_ENTER;
};
